import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.grey["A400"],
				overflow: "scroll"
			},
			bgButton: {
				background: theme.palette.common.white,
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				borderRadius: 6,
				height: "100%",
				width: "100%",
				padding: 10
			},
			textButton: {
				fontSize: 13,
				fontWeight: 500,
				height: 40,
				textTransform: "none",
				color: theme.palette.primary.contrastText
			}
		}),
	{
		name: "MenuHistoryOrder",
		index: 1
	}
);

export default useStyles;
